// eslint-disable

import type { Container, DisplayObject, Stage } from '@suntex.classic/createjs';

import { ArrayUtil } from './ArrayUtil';
import { Calculator } from './Calculator';
import { GraphicsUtil } from './GraphicsUtil';
import { TestUtil } from './TestUtil';
import './createjs';

export function UIUtil() {}

//Private static properties
UIUtil._stage = null as Stage | null;
UIUtil._parameters = {};
UIUtil._tweeningEnabled = true;

UIUtil._keyDownFunction = null as any;
UIUtil._keyUpFunction = null as any;
UIUtil._keyCodeFunctions = [];

UIUtil._links = {};
UIUtil._timers = {};
UIUtil._delays = {};
UIUtil._tweens = {};

UIUtil._dragging = null as any;
UIUtil._draggableObjects = {} as Record<any, any>;

UIUtil._htmlOverlays = [];
UIUtil._veilSprite = null as DisplayObject | null;

UIUtil._validationTimer = 0 as NodeJS.Timeout | 0;
UIUtil._validationInterval = 2500;
UIUtil._validationFail = null as any;
UIUtil._lastCheckIn = null;

UIUtil.setStage = function (stage) {
  UIUtil._stage = stage;
};

UIUtil.veil = function () {
  UIUtil._veilSprite = GraphicsUtil.createSprite();
  GraphicsUtil.beginFill(UIUtil._veilSprite, 0xffffff);
  GraphicsUtil.drawRect(
    UIUtil._veilSprite,
    0,
    0,
    (UIUtil._stage!.canvas as HTMLCanvasElement).width,
    (UIUtil._stage!.canvas as HTMLCanvasElement).height,
  );
  (UIUtil._stage!.children[0] as Container).addChildAt(
    UIUtil._veilSprite,
    UIUtil._stage!.children.length - 1,
  );
  UIUtil.bringToFront(UIUtil._veilSprite);
  UIUtil._stage!.update();
};

UIUtil.unveil = function () {
  (UIUtil._stage!.children[0] as Container).removeChild(UIUtil._veilSprite!);
};

UIUtil.inJavascript = function () {
  return true;
};

UIUtil.inUserAgent = function (searchTerm) {
  return (
    navigator.userAgent.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
  );
};

UIUtil.navigate = function (href) {
  window.location.href = href;
};

/**
 * @deprecated This is an enormous security risk
 */
UIUtil.callJSFunction = function (func, ...args) {
  const argStr = args.map((arg) => `"${arg}"`).join(',');
  const scriptStr = func + '(' + argStr + ')';
  eval(scriptStr);
};

UIUtil.formatNumber = function (num) {
  const array = num.toString().split('');
  let index = -3;
  while (array.length + index > 0) {
    array.splice(index, 0, ',');
    // Decrement by 4 since we just added another unit to the array.
    index -= 4;
  }
  return array.join('');
};

UIUtil.createNew = function (className) {
  try {
    if (window.lib![className]) return new window.lib![className]();
    else return new (window as any).className(); //JASON: the as any is because window.className is not a known variable. bug?
  } catch (e) {
    TestUtil.warn("'" + className + "' is not a function");
  }
};

UIUtil.setFrame = function (movieClip, frame, onFrameLoaded?) {
  if (movieClip != undefined) {
    if (movieClip && movieClip.timeline) {
      const newFrame = Calculator.bound(
        parseInt(frame),
        1,
        movieClip.timeline.duration,
      );
      if (Calculator.isInt(newFrame)) movieClip.gotoAndStop(newFrame - 1);
      else movieClip.gotoAndStop(frame);
    } else {
      TestUtil.warn("'movieclip' is undefined.");
    }
  }
  return movieClip;
};

UIUtil.playFrame = function (movieClip, frame) {
  if (movieClip != undefined) {
    if (movieClip && movieClip.timeline) {
      movieClip.gotoAndPlay(frame);
    } else {
      TestUtil.warn("'movieclip' is undefined.");
    }
    return movieClip;
  }
};

UIUtil.getCurrentFrame = function (movieClip) {
  if (movieClip != undefined) {
    let frame = 1;
    if (movieClip && movieClip.timeline) {
      frame = movieClip.timeline.position + 1;
    } else {
      TestUtil.warn("'movieclip' is undefined.");
    }
    return frame;
  }
};

UIUtil.getTranslation = function (from, to) {
  const fromPoint = from.parent.localToGlobal(from.x, from.y);
  const toPoint = to.parent.localToGlobal(to.x, to.y);
  const point = {} as any;

  point.x = (toPoint.x - fromPoint.x) * (1 / window.stage!.scaleX); //JPW Fix Stage Scaling issue
  point.y = (toPoint.y - fromPoint.y) * (1 / window.stage!.scaleY);
  return point;
};

/* Parameters */

UIUtil.addParameter = function (key, value) {
  UIUtil._parameters[key] = value;
};
UIUtil.getParam = function (key) {
  return UIUtil._parameters[key];
};
UIUtil.getParamAsInt = function (key, def?) {
  return Calculator.getInt(UIUtil._parameters[key], def);
};
UIUtil.getParamAsBool = function (key) {
  return Calculator.getBool(UIUtil._parameters[key]);
};

/* Containers */
//UIUtil.find = function (...args: any[]){

//	var object;
//	var varsString;
//	var varName;
//	var varsArr;
//	try{
//		if(arguments.length==0){
//			TestUtil.warn("No arguments supplied");
//		}
//		else if (arguments.length == 1)
//		{
//			try{
//				var direct = eval(name);
//				if(direct)return direct;
//			}catch(e){}
//			varsString = arguments[0];
//			varsArr = varsString.split(".");
//			varName = varsArr.shift();
//			object = eval(varName);
//		}else{
//			var object = arguments[0];
//			varsString = arguments[1];
//			if(object == null)throw new Error("parent is undefined");
//			varsArr = varsString.split(".");
//		}
//		while(varsArr.length > 0){
//			varName = varsArr.shift();
//			object = UIUtil.getChild(object, varName);
//			if(object == null)throw new Error("'"+varName+"' is undefined");
//		}
//		return object;
//	}catch(e){
//		TestUtil.warn("'"+varsString+"' could not be resolved: "+e.message);
//		return null;
//	}
//}

UIUtil.find = function (object: any, varsString: string) {
  let varName;
  let varsArr;
  try {
    if (object == null) throw new Error('parent is undefined');

    varsArr = varsString.split('.');

    while (varsArr.length > 0) {
      varName = varsArr.shift();
      object = UIUtil.getChild(object, varName);
      if (object == null) throw new Error("'" + varName + "' is undefined");
    }
    return object;
  } catch (e) {
    TestUtil.warn(
      "'" + varsString + "' could not be resolved: " + (e as Error).message,
    );
    return null;
  }
};

//window.__ = UIUtil.find;

UIUtil.findOnFrame = function (parent, childName, frame) {
  if (frame == 1) return UIUtil.find(parent, childName);
  else {
    const childNameArr = childName.split('.');
    childNameArr[0] += '_' + (frame - 1);
    return UIUtil.find(parent, childNameArr.join('.'));
  }
};

UIUtil.createContainer = function () {
  return new createjs.MovieClip();
};
UIUtil.getChild = function (parent, name) {
  if (!parent) {
    TestUtil.warn("'parent' is undefined");
    return null;
  }
  let element = parent[name];
  let i = 1;
  while (typeof element == 'undefined' && i < 100) {
    element = parent[name + '_' + i];
    i++;
  }
  return element;
};
UIUtil.removeAllChildren = function (parent, children?) {
  if (children == null) {
    for (var i in parent.children) {
      parent.removeChild(parent.children[i]);
    }
  } else {
    for (var i in children) {
      parent.removeChild(children[i]);
    }
  }
};
UIUtil.getChildren = function (parent) {
  return parent.children;
};

UIUtil.bringToFront = function (mc, place?) {
  place = place || 1;
  if (mc.parent) {
    //TestUtil.log(mc.name+":"+mc.parent.getChildIndex(mc));
    //mc.parent.setChildIndex(mc, mc.parent.children.length - place);
    //mc.parent.setChildIndex(mc, mc.parent.numChildren - place);
    mc.parent.addChild(mc);
    //TestUtil.log(mc.name+":"+mc.parent.getChildIndex(mc));
  } else {
    TestUtil.warn('mc.parent is undefined');
  }
};
UIUtil.sendToBack = function (mc, place) {
  if (mc.parent) {
    mc.parent.setChildIndex(mc, place);
  } else {
    TestUtil.warn('mc.parent is undefined');
  }
};

/* HTML Text */

UIUtil.htmlText = function (textfield, text, fontSize?) {
  textfield.text = '';
  UIUtil._htmlOverlays.push(textfield);
  textfield.setHtmlText(text, fontSize);
};

/* Visual */

UIUtil.hide = function (o, ms?, ease?) {
  if (o == null) {
    TestUtil.warn('Object is not defined');
    return;
  }
  if (typeof o !== 'object') {
    TestUtil.warn(`Expected object is type ${typeof o}`);
    return;
  }
  if (ms == null) ms = 0;
  if (ms <= 0) {
    o.alpha = 0.0;
    o.visible = false;
  } else {
    UIUtil.tween(o, 'alpha', 0.0, ms, ease, UIUtil.hide, [o]);
  }
  if (UIUtil._htmlOverlays.length > 0) UIUtil._hideHtmlOverlays(o);
};
UIUtil._hideHtmlOverlays = function (o) {
  if (ArrayUtil.contains(UIUtil._htmlOverlays, o)) o.hideHtmlOverlay();
  else if (o.children && o.children.length > 0) {
    for (let i = 0; i < o.children.length; i++) {
      UIUtil._hideHtmlOverlays(o.children[i]);
    }
  }
};
UIUtil.show = function (o, ms?: number, ease?) {
  if (ms == null) ms = 0;
  if (ms <= 0) {
    o.visible = true;
    o.alpha = 1.0;
  } else {
    o.visible = true;
    UIUtil.tween(o, 'alpha', 1.0, ms, ease); //, UIUtil.show, [o]);
  }
  if (UIUtil._htmlOverlays.length > 0) UIUtil._showHtmlOverlays(o, true);
};
UIUtil._showHtmlOverlays = function (o, testVisibility?) {
  if (testVisibility) {
    if (!UIUtil._isVisible(o.parent)) return false;
  }
  if (ArrayUtil.contains(UIUtil._htmlOverlays, o)) o.showHtmlOverlay();
  else if (o.children && o.children.length > 0) {
    for (let i = 0; i < o.children.length; i++) {
      UIUtil._showHtmlOverlays(o.children[i]);
    }
  }
};
UIUtil._isVisible = function (o) {
  if (o == UIUtil._stage) return true;
  else {
    if (o.visible) return UIUtil._isVisible(o.parent);
    return false;
  }
};
UIUtil.moveTo = function (o, x, y, ms?, ease?) {
  UIUtil.tween(o, 'x', x, ms, ease);
  UIUtil.tween(o, 'y', y, ms, ease);
};
UIUtil.scaleTo = function (o, scale, ms?, ease?) {
  if (ms == null) ms = 0;
  if (ms <= 0) {
    o.scaleX = o.scaleY = scale;
  } else {
    UIUtil.tween(o, 'scaleX', scale, ms, ease);
    UIUtil.tween(o, 'scaleY', scale, ms, ease);
  }
};
UIUtil.fadeTo = function (o, alpha, ms?: number, ease?) {
  if (ms == null) ms = 0;
  if (o.visible == false) {
    o.alpha = 0;
    o.visible = true;
  }
  UIUtil.tween(o, 'alpha', alpha, ms, ease);
};
UIUtil.tweenTo = function (
  o,
  x,
  y,
  scale?: number,
  alpha?: number,
  ms?: number,
  ease?,
) {
  if (scale == null) scale = 1.0;
  if (alpha == null) alpha = 1.0;
  if (ms == null) ms = 800;
  if (ease == null) ease = 'easeInOut';

  UIUtil.tween(o, 'x', x, ms, ease);
  UIUtil.tween(o, 'y', y, ms, ease);
  UIUtil.tween(o, 'scaleX', scale, ms, ease);
  UIUtil.tween(o, 'scaleY', scale, ms, ease);
  UIUtil.tween(o, 'alpha', alpha, ms, ease);
};
UIUtil.setRegistrationPoint = function (movieClip, x, y) {
  movieClip.x = movieClip.x - (movieClip.regX - x);
  movieClip.regX = x;

  movieClip.y = movieClip.y - (movieClip.regY - y);
  movieClip.regY = y;
};
UIUtil.stretch = function (movieClip, scale, direction) {
  switch (direction) {
    case UIUtil.RIGHT:
      movieClip.regX = 0;
      movieClip.x = 0;
      movieClip.scaleX = scale;
      break;
    case UIUtil.UP:
      movieClip.regY = 0;
      movieClip.y = 0;
      movieClip.scaleY = scale;
      break;
    default:
      TestUtil.warn("Invalid value for 'direction'");
  }
};
UIUtil.lineUp = function (
  movieClips,
  centerX,
  y,
  spacing,
  scale,
  maxWidth,
  ms,
) {
  if (y == null) y = 0;
  if (spacing == null) spacing = 0;
  if (scale == null) scale = 1.0;
  if (maxWidth == null) maxWidth = 0;
  if (ms == null) ms = 800;

  if (spacing == 0)
    spacing = movieClips[0].width * (scale / movieClips[0].scaleX);

  if (maxWidth > 0) {
    const newScale = (scale * maxWidth) / (movieClips.length * spacing);
    if (newScale < scale) {
      spacing *= newScale / scale;
      scale = newScale;
    }
  }
  for (let i = 0; i < movieClips.length; i++) {
    const mc = movieClips[i];
    const targetX = centerX + (i - movieClips.length / 2.0 + 0.5) * spacing;
    UIUtil.tweenTo(mc, targetX, y, scale, mc.alpha, ms);
  }
};

UIUtil.pulse = function (obj, ms, target, prop) {
  if (obj != null) {
    if (target == null) {
      target = 1.0;
    }
    if (prop == null) {
      prop = 'alpha';
    }
    UIUtil.tween(obj, prop, target, ms / 2, 'easeInOut', UIUtil._pulseBack, [
      obj,
      ms,
      obj[prop],
      prop,
    ]);
  }
};

UIUtil._pulseBack = function (obj, ms, target, prop) {
  UIUtil.tween(obj, prop, target, ms / 2, 'easeInOut');
};

/* Tweening */

UIUtil.tween = function <T extends object, K extends keyof T, A extends any[]>(
  obj: T | null | undefined,
  prop: K,
  target: T[K],
  ms?: number,
  ease?:
    | 'linear'
    | 'easeIn'
    | 'easeInOut'
    | 'easeOut'
    | 'strongIn'
    | 'strongInOut'
    | 'strongOut'
    | 'elasticIn'
    | 'elasticInOut'
    | 'elasticOut'
    | 'bounceIn'
    | 'bounceInOut'
    | 'bounceOut'
    | 'backIn'
    | 'backInOut'
    | 'backOut',
  onComplete?: (...args: A) => void,
  callbackArgs?: A,
) {
  if (obj === undefined) {
    return;
  }
  if (obj !== null) {
    //if(obj[prop]==NaN)obj[prop] = 0;
    if (obj[prop] == target) {
      if (onComplete != null) UIUtil.delay(onComplete, ms, callbackArgs);
      return;
    } else if (ms == 0 || !UIUtil._tweeningEnabled) {
      obj[prop] = target;
      if (onComplete != null)
        onComplete(...(callbackArgs ?? ([] as unknown[] as A)));
    } else {
      const props: Partial<T> = {};
      props[prop] = target;
      let easeFunction;
      switch (ease) {
        case 'linear':
          easeFunction = createjs.Ease.linear;
          break;

        case 'easeIn':
          easeFunction = createjs.Ease.quadIn;
          break;
        case 'easeInOut':
          easeFunction = createjs.Ease.quadInOut;
          break;
        case 'easeOut':
          easeFunction = createjs.Ease.quadOut;
          break;

        case 'strongIn':
          easeFunction = createjs.Ease.quartIn;
          break;
        case 'strongInOut':
          easeFunction = createjs.Ease.quartInOut;
          break;
        case 'strongOut':
          easeFunction = createjs.Ease.quartOut;
          break;

        case 'elasticIn':
          easeFunction = createjs.Ease.elasticIn;
          break;
        case 'elasticInOut':
          easeFunction = createjs.Ease.elasticInOut;
          break;
        case 'elasticOut':
          easeFunction = createjs.Ease.elasticOut;
          break;

        case 'bounceIn':
          easeFunction = createjs.Ease.bounceIn;
          break;
        case 'bounceInOut':
          easeFunction = createjs.Ease.bounceInOut;
          break;
        case 'bounceOut':
          easeFunction = createjs.Ease.bounceOut;
          break;

        case 'backIn':
          easeFunction = createjs.Ease.backIn;
          break;
        case 'backInOut':
          easeFunction = createjs.Ease.backInOut;
          break;
        case 'backOut':
          easeFunction = createjs.Ease.backOut;
          break;

        default:
          easeFunction = createjs.Ease.quadInOut;
          break;
      }

      //TestUtil.log("tweens on obj-> " + obj.tweenjs_count.toString());
      return createjs.Tween.get(obj)
        .to(props, ms, easeFunction)
        .call(function () {
          if (onComplete != null) {
            onComplete(...(callbackArgs ?? ([] as unknown[] as A)));
          }
        });
    }
  } else {
    TestUtil.warn('obj cannot be null', 'UIUtil.tween');
  }
};

UIUtil.disableAnimation = function () {
  UIUtil._tweeningEnabled = false;
};

UIUtil.stopAllTweensAndDelays = function () {
  createjs.Tween.removeAllTweens();
  UIUtil.cancelAllDelays();
};

UIUtil.removeObjectTweens = function (target) {
  createjs.Tween.removeTweens(target);
};

/* Mouse Interaction */
//JASON: recursive not used?
UIUtil.enable = function (o, recursive?) {
  //if(recursive==null)recursive = false;
  //if(o.hasOwnProperty('mouseEnabled')){
  o.mouseEnabled = true;
  //	if(recursive && o.hasOwnProperty('children'))ArrayUtil.forEachIn(UIUtil.getChildren(o), UIUtil.enable);
  //}
};
//JASON: recursive not used?
UIUtil.disable = function (o, recursive?) {
  //if(recursive==null)recursive = true;
  //if(o.hasOwnProperty('mouseEnabled')){
  o.mouseEnabled = false;
  //if(recursive && o.hasOwnProperty('children'))ArrayUtil.forEachIn(UIUtil.getChildren(o), UIUtil.disable);
  //}
};
UIUtil.getMousePosition = function (e, movieClip?) {
  if (movieClip != null)
    return UIUtil.globalToLocal(movieClip, e.stageX, e.stageY);
  else return new createjs.Point(e.stageX, e.stageY);
};
UIUtil.globalToLocal = function (movieClip, x, y) {
  return movieClip.globalToLocal(x, y);
};

//JASON: some caller used three args, but the third is never used
UIUtil.onClick = function (
  movieClip,
  onClick: (e: createjs.MouseEvent) => void,
  dummy?,
) {
  if (onClick == null) TestUtil.warn("'onClick' is null or not defined");
  movieClip.addEventListener('click', onClick);
};

UIUtil.onMouseDownAndUp = function (
  movieClip,
  onDown: (e: createjs.MouseEvent) => void,
  onUp: (e: createjs.MouseEvent) => void,
) {
  if (onDown != null) {
    movieClip.addEventListener('mousedown', onDown);
  }
  if (onUp != null) {
    movieClip.addEventListener('pressup', onUp);
  }
};

UIUtil.onMouseOver = function (
  movieClip,
  onMouseOver: (e: createjs.MouseEvent) => void,
) {
  if (onMouseOver != null) {
    movieClip.addEventListener('mouseover', onMouseOver);
  }
};
UIUtil.onMouseOut = function (
  movieClip,
  onMouseOut: (e: createjs.MouseEvent) => void,
) {
  if (onMouseOut != null) {
    movieClip.addEventListener('mouseout', onMouseOut);
  }
};
UIUtil.onMouseMove = function (
  movieClip,
  onDown: (e: createjs.MouseEvent) => void,
  onMove: (e: createjs.MouseEvent) => void,
  onUp: (e: createjs.MouseEvent) => void,
) {
  if (onDown != null) {
    movieClip.addEventListener('mousedown', onDown);
  }
  if (onMove != null) {
    movieClip.addEventListener('pressmove', onMove);
  }
  if (onUp != null) {
    movieClip.addEventListener('pressup', onUp);
  }
};

/* MouseOver Effects */

UIUtil.globalToLocalXY = function (movieClip, x, y) {
  const p = UIUtil.globalToLocal(movieClip, x, y);
  return [p.x, p.y];
};

UIUtil.useHandCursor = function (movieClip, handCursor?) {
  if (handCursor == null) handCursor = true;

  if (handCursor) movieClip.cursor = 'pointer';
  else movieClip.cursor = 'default';
  /*
	if(handCursor){
		movieClip.onMouseOver = UIUtil._onMouseOver;
		movieClip.onMouseOut = UIUtil._onMouseOut;
	}else{
		UIUtil._onMouseOut();
		movieClip.onMouseOver = null;
		movieClip.onMouseOut = null;
	}*/
};

// TODO
UIUtil.swellOnMouseOver = function (movieClip) {
  //UIUtil.onMouseOver(movieClip, swell);
  //UIUtil.onMouseOut(movieClip, unswell);
};
UIUtil.disableSwellOnMouseOver = function (movieClip) {
  //movieClip.removeEventListener( MouseEvent.ROLL_OVER, UIUtil.swell );
  //movieClip.removeEventListener( MouseEvent.ROLL_OUT, UIUtil.unswell );
};
UIUtil.swell = function (e) {
  /*var mc = MovieClip(e.currentTarget);
	var originalScale = mc["originalScale"] ? mc["originalScale"] : mc.scaleX;
	mc["originalScale"] = originalScale;
	var targetScale = 1.1 * originalScale;
	UIUtil.tween(mc, 'scaleX', targetScale, 1000, 'elasticOut');
	UIUtil.tween(mc, 'scaleY', targetScale, 1000, 'elasticOut');*/
};
UIUtil.unswell = function (e) {
  /*
	var mc = MovieClip(e.currentTarget);
	var originalScale = mc["originalScale"] ? mc["originalScale"] : 1.0;
	UIUtil.tween(mc, 'scaleX', originalScale, 1000, 'elasticOut');
	UIUtil.tween(mc, 'scaleY', originalScale, 1000, 'elasticOut');*/
};

UIUtil.createButtonOld = function (movieClip, onClick, value) {
  UIUtil.useHandCursor(movieClip);
  UIUtil.onClick(movieClip, onClick);
  if (value != null) movieClip['value'] = value;
};

UIUtil.createButton = function (
  movieClip,
  onClick,
  value?,
  onRollOver?,
  onRollOut?,
) {
  UIUtil.useHandCursor(movieClip);
  UIUtil.onClick(movieClip, onClick);
  if (onRollOver != null) UIUtil.onMouseOver(movieClip, onRollOver);
  if (onRollOut != null) UIUtil.onMouseOut(movieClip, onRollOut);
  if (value != null) movieClip['value'] = value;
};

UIUtil.createSimpleButton = function (
  movieClip,
  onClickFunc,
  value?,
  thisArg?,
) {
  //UIUtil.useHandCursor(movieClip);
  UIUtil.onClick(movieClip, onClickFunc, thisArg);
  if (value != null) movieClip['value'] = value;
  UIUtil.onMouseOver(movieClip, UIUtil._onSimpleButtonMouseOver);
  UIUtil.onMouseOut(movieClip, UIUtil._onSimpleButtonMouseOut);
  //UIUtil.onMouseDownAndUp(movieClip, UIUtil._onSimpleButtonMouseDown, UIUtil._onSimpleButtonMouseUp);
  UIUtil.setFrame(movieClip, 1);
};
UIUtil.createSimpleToggleButton = function (
  movieClip,
  onToggleFunc,
  initialValue?,
) {
  if (!Calculator.isDefined(initialValue)) initialValue = true;

  UIUtil.useHandCursor(movieClip);

  movieClip['value'] = initialValue;
  movieClip['onToggle'] = onToggleFunc;

  UIUtil.onClick(movieClip, UIUtil._onSimpleToggleButtonClick);
  UIUtil.onMouseOver(movieClip, UIUtil._onSimpleToggleButtonMouseOver);
  UIUtil.onMouseOut(movieClip, UIUtil._onSimpleToggleButtonMouseOut);
  UIUtil.setFrame(movieClip, 1);

  movieClip.toggleOn = function () {
    movieClip['value'] = true;
    movieClip.gotoAndStop(1);
  };
  movieClip.toggleOff = function () {
    movieClip['value'] = false;
    movieClip.gotoAndStop(3);
  };
};
UIUtil.createLink = function (movieClip, url) {
  UIUtil._links[movieClip.id] = url;
  UIUtil.useHandCursor(movieClip, true);
  UIUtil.onClick(movieClip, UIUtil._clickLink);
};
UIUtil._clickLink = function (e) {
  const mc = UIUtil.getEventTarget(e);
  UIUtil.navigate(UIUtil._links[mc.id]);
};

UIUtil.getEventTarget = function <T>(e: { currentTarget: T & DisplayObject }) {
  return e.currentTarget;
};
UIUtil.createEvent = function (target) {
  return { currentTarget: target, target: target };
};

UIUtil.makeDraggablev2 = function (
  movieClip,
  onDragStart,
  onDrag,
  onDragRelease,
) {
  movieClip.on('pressmove', function (evt) {
    //TestUtil.log("moving");
    const p = window.stage!.globalToLocal(evt.stageX, evt.stageY);
    evt.currentTarget.x = p.x;
    evt.currentTarget.y = p.y;
    window.stage!.update();
  });
  //movieClip.on("move", function (evt) { TestUtil.log("moving");})
  movieClip.on('pressup', function (evt) {
    TestUtil.log('up');
  });
};

//JASON: commented out because it contains an error (the reference to "draggingPiece"), and doesn't appear to be used
//UIUtil.makeDraggablev1 = function(movieClip, onDragStart, onDrag, onDragRelease) {
//	movieClip.onPress = function(e){
//		if (onDragStart!=null) onDragStart(e);
//		e.onMouseMove = function(e){
//			if ( movieClip.parent ) {
//				var point = UIUtil.getMousePosition(e, movieClip.parent);
//				UIUtil.moveTo(draggingPiece, point.x, point.y);
//			}
//			if (onDrag!=null) onDrag(e);
//		}

//		e.onMouseUp = function(e){
//			if (onDragRelease!=null) onDragRelease(e);
//		};
//		e.onMouseOut = function(e){
//			if (onDragRelease!=null) onDragRelease(e);
//		}
//	}

//	UIUtil._stage.addEventListener("pressup", UIUtil._onDrop);
//	movieClip.addEventListener("mousedown", UIUtil._onDrag);

//}

UIUtil.makeDraggable = function (mc, onDrag, onDrop, boundsRect) {
  UIUtil.useHandCursor(mc);
  const o = {} as any;
  const container = mc.parent;

  o.onDrag = onDrag;
  o.onDrop = onDrop;
  if (boundsRect != null)
    o.bounds = new createjs.Rectangle(
      boundsRect[0],
      boundsRect[1],
      boundsRect[2],
      boundsRect[3],
    );
  else o.bounds = null;

  UIUtil._draggableObjects[mc] = o;

  //stage.setChildIndex( mc, stage.numChildren-1);
  /*
		if (onDragStart!=null) {
            onDragStart(e);
        }

		e.onMouseMove = function(e){
			if ( mc.parent ) {
				var point = UIUtil.getMousePosition(e, mc.parent);
				UIUtil.moveTo(draggingPiece, point.x, point.y);
			}
			if (onDrag!=null) onDrag(e);
		}
		
		e.onMouseUp = function(e){
			if (onDragRelease!=null) onDragRelease(e);
		};
		e.onMouseOut = function(e){
			if (onDragRelease!=null) onDragRelease(e);
		}
*/

  UIUtil._stage!.addEventListener('pressup', UIUtil._onDrop);
  mc.addEventListener('pressmove', UIUtil._onDrag);
};

UIUtil.checkForCollision = function (mc1, mc2) {
  //returns 1 if MC's are colliding...0 if not.
  if (mc1 == null || mc2 == null) {
    return 0;
  }

  const a = mc1.globalToLocal(0, 0);
  const b = mc2.globalToLocal(0, 0);
  //TestUtil.logObject(mc1);
  //TestUtil.logObject(mc2);

  //TestUtil.log("a.x:"+a.x);
  //TestUtil.log("a.y:"+a.y);
  //TestUtil.log("b.x:"+b.x);
  //TestUtil.log("b.y:"+b.y);

  if (
    a.x < b.x + mc2.width &&
    a.x + mc1.width > b.x &&
    a.y < b.y + mc2.height &&
    a.y + mc1.height > b.y
  ) {
    //TestUtil.log("collision");
    return 1;
  } else {
    return 0;
  }
};

/* private methods */
UIUtil._onDrag = function (e) {
  //TestUtil.log("_onDrag");

  //if (UIUtil._dragging) {
  const mc = UIUtil.getEventTarget(e);
  if (mc == undefined) {
    return;
  }
  const container = mc.parent;
  const key = mc.toString();
  const func = UIUtil._draggableObjects[key].onDrag;
  const bounds = UIUtil._draggableObjects[key].bounds;
  const objBounds = mc.getBounds();
  mc['stageX'] = e.stageX;
  mc['stageY'] = e.stageY;

  container.setChildIndex(mc, container.numChildren - 1);

  //var localToTrack = mc.globalToLocal(e.stageX, e.stageY);

  //var targetX = Math.max(bounds.x, Math.min(bounds.x + bounds.width - objBounds.width, localToTrack.x)); //  + e.currentTarget.regX
  //var targetY = Math.max(bounds.y, Math.min(bounds.y + bounds.height - objBounds.height, localToTrack.y)); // + e.currentTarget.regY

  //e.currentTarget.x = targetX;
  //e.currentTarget.y = targetY;*/

  UIUtil._dragging = mc;
  if (func != null) func.call(null, UIUtil.createEvent(mc));
  //}
};

UIUtil._onDrop = function (e) {
  if (UIUtil._dragging == undefined) {
    return;
  }
  if (UIUtil._dragging) {
    const mc = UIUtil._dragging;
    const func = UIUtil._draggableObjects[mc].onDrop;
    //mc.stopDrag();
    UIUtil._dragging = null;

    if (func != null) func.call(null, UIUtil.createEvent(mc));
  }
};

UIUtil.forceDrop = function () {
  if (UIUtil._dragging == undefined) {
    return;
  }
  if (UIUtil._dragging != null) {
    //REDUNDANT
    if (UIUtil._dragging) {
      const mc = UIUtil._dragging;
      const func = UIUtil._draggableObjects[mc].onDrop;
      //mc.stopDrag();
      UIUtil._dragging = null;
      if (func != null) func.call(null, UIUtil.createEvent(mc));
    }
  }
};

UIUtil._onSimpleButtonMouseOver = function (e) {
  UIUtil.setFrame(UIUtil.getEventTarget(e), 2);
  UIUtil._onMouseOver(e);
};
UIUtil._onSimpleButtonMouseOut = function (e) {
  UIUtil.setFrame(UIUtil.getEventTarget(e), 1);
  UIUtil._onMouseOut(e);
};
UIUtil._onSimpleButtonMouseDown = function (e) {
  UIUtil.setFrame(UIUtil.getEventTarget(e), 3);
};
UIUtil._onSimpleButtonMouseUp = function (e) {
  UIUtil.setFrame(UIUtil.getEventTarget(e), 2);
};

UIUtil._onSimpleToggleButtonClick = function (e) {
  const mc = UIUtil.getEventTarget(e);
  if (mc['value'] == true) mc['value'] = false;
  else mc['value'] = true;
  UIUtil.setFrame(mc, mc['value'] ? 1 : 3);
  mc['onToggle'].call(null, mc['value'], mc);
};
UIUtil._onSimpleToggleButtonMouseOver = function (e) {
  const mc = UIUtil.getEventTarget(e);
  UIUtil.setFrame(mc, mc['value'] ? 2 : 4);
  UIUtil._onMouseOver(e);
};
UIUtil._onSimpleToggleButtonMouseOut = function (e) {
  const mc = UIUtil.getEventTarget(e);
  UIUtil.setFrame(mc, mc['value'] ? 1 : 3);
  UIUtil._onMouseOut(e);
};

UIUtil._onMouseOver = function (e) {
  document.body.style.cursor = 'pointer';
};
UIUtil._onMouseOut = function (e) {
  document.body.style.cursor = 'default';
};

/* Keyboard Interaction */

UIUtil.clearKeyDown = function (keyDownFunction) {
  UIUtil._keyDownFunction = null;
  document.onkeydown = null;
};
UIUtil.setKeyDown = function (keyDownFunction) {
  UIUtil._keyDownFunction = keyDownFunction;
  document.onkeydown = UIUtil._onKeyDown;
};
UIUtil.setKeyUp = function (keyUpFunction) {
  UIUtil._keyUpFunction = keyUpFunction;
  document.onkeyup = UIUtil._onKeyUp;
};

////JASON: fatal bug? is this used anywhere?
//UIUtil.setKeyAction = function(keyCode, keyCodeFunction){
//	UIUtil._keyCodeFunctions[keyCode] = keyUpFunction;
//	document.onkeydown = UIUtil._onKeyDown;
//}
UIUtil._onKeyDown = function (e) {
  if (UIUtil._keyDownFunction) UIUtil._keyDownFunction(e);
  if (ArrayUtil.contains(UIUtil._keyCodeFunctions, e.keyCode)) {
    UIUtil._keyCodeFunctions[e.keyCode].call();
  }
};
UIUtil._onKeyUp = function (e) {
  UIUtil._keyUpFunction(e);
};

/* Timing */

UIUtil.setTimeout = function (onTime, ms) {
  setTimeout(onTime, ms);
};

//declare let timerID: any;

UIUtil.setInterval = function (onTick, ms) {
  const timerID = setInterval(onTick, 1000);
  UIUtil._timers[onTick.name] = timerID;
};
UIUtil.clearInterval = function (onTick) {
  clearInterval(UIUtil._timers[onTick.name]);
  delete UIUtil._timers[onTick.name];
};

UIUtil.clearAllIntervals = function () {
  for (const timerID in UIUtil._timers) {
    clearInterval(UIUtil._timers[timerID]);
    delete UIUtil._timers[timerID];
  }
};

UIUtil.delay = function (func, ms, args?, thisArg?) {
  thisArg = thisArg || null;
  const timerID = setTimeout(function () {
    func.apply(thisArg, args);
    delete UIUtil._delays[timerID];
  }, ms).toString();

  UIUtil._delays[timerID] = func;
};

UIUtil.cancelDelay = function (func) {
  for (const timerID in UIUtil._delays) {
    if (UIUtil._delays[timerID] == func) {
      clearTimeout(timerID);
      delete UIUtil._delays[timerID];
    }
  }
};
UIUtil.cancelAllDelays = function () {
  for (const timerID in UIUtil._delays) {
    clearTimeout(timerID);
    delete UIUtil._delays[timerID];
  }
};

// Timer tampering Validation (3 functions below)
// This feature used to be used to prevent a cheat freezing the timer on a Mac by holding down the Apple Menu, which would freeze all Javascript Execution
// and allow a student to Solve a problem and resume the timer.
// This is largely no longer necessary as most games are no longer timed, and the easy cheat seems no longer present on the Mac.

UIUtil.validateTiming = function (onFail) {
  if (onFail != null) {
    UIUtil._validationFail = onFail;
    UIUtil._validationTimer = setInterval(
      UIUtil._validateTimingTick,
      UIUtil._validationInterval,
    );
  } else {
    TestUtil.warn('onFail cannot be null', 'UIUtil.validateTiming');
  }
};
UIUtil.stopTimingValidation = function () {
  clearInterval(UIUtil._validationTimer);
  UIUtil._validationFail = null;
};
UIUtil._validateTimingTick = function (e) {
  const currentTime = new Date() as any;
  if (UIUtil._lastCheckIn != null) {
    if (currentTime - UIUtil._lastCheckIn > UIUtil._validationInterval * 2) {
      if (UIUtil._validationFail != null) {
        UIUtil._validationFail.call();
      } else {
        TestUtil.warn(
          'no failure function to call',
          'UIUtil.validateTimingTick',
        );
      }
    }
  }
  UIUtil._lastCheckIn = currentTime;
};

UIUtil.BACKSPACE = 8;
UIUtil.ENTER = 13;
UIUtil.SPACE = 32;
UIUtil.LEFT = 37;
UIUtil.UP = 38;
UIUtil.RIGHT = 39;
UIUtil.DOWN = 40;
UIUtil.DELETE = 46;

UIUtil.Key0 = 48;
UIUtil.Key1 = 49;
UIUtil.Key2 = 50;
UIUtil.Key3 = 51;
UIUtil.Key4 = 52;
UIUtil.Key5 = 53;
UIUtil.Key6 = 54;
UIUtil.Key7 = 55;
UIUtil.Key8 = 56;
UIUtil.Key9 = 57;

UIUtil.Numpad0 = 96;
UIUtil.Numpad1 = 97;
UIUtil.Numpad2 = 98;
UIUtil.Numpad3 = 99;
UIUtil.Numpad4 = 100;
UIUtil.Numpad5 = 101;
UIUtil.Numpad6 = 102;
UIUtil.Numpad7 = 103;
UIUtil.Numpad8 = 104;
UIUtil.Numpad9 = 105;

UIUtil.Multiply = 106;
UIUtil.Add = 107;
UIUtil.Subtract = 109;
UIUtil.Decimal = 110;
UIUtil.Divide = 111;

UIUtil.NUMLOCK = 144;

UIUtil.PLUS = 187;
UIUtil.HYPHEN = 189;
UIUtil.PERIOD = 190;
UIUtil.SLASH = 191;
